import Header from '@components/Header/Header'

import icon from '@static/vectors/icon-datalab.svg'
import './NotFound.css'

export default function NotFound() {
  return (
    <div id="not-found" className="page">
      <Header />
      <section id="not-found-wrapper">
        <div className="container">
          <img src={icon} alt="dataLab icon" />
          <h1>
            <strong>404</strong>
            <span>Not Found</span>
          </h1>
        </div>
      </section>
    </div>
  )
}
